import { App } from '@capacitor/app'

export default defineNuxtPlugin(() => {
  const isNative = useIsNative()

  if (!isNative) {
    return
  }

  try {
    App.addListener('appUrlOpen', (event: { url: string }) => {
      try {
        const url = new URL(event.url)

        // Handle staging URLs
        if (url.hostname.endsWith('.casewiseapp.com')) {
          const path = url.pathname + url.search

          //TODO: This is a temporary fix to avoid a vue routing race condition. We need to find a better solution for this. Using window.location to force a clean navigation
          const baseUrl = window.location.origin
          const fullUrl = `${baseUrl}${path}`
          window.location.replace(fullUrl)
        }
      } catch (error) {
        console.error('Deep linking error:', error)
      }
    })
  } catch (error) {
    console.error('Deep linking error:', error)
  }
})
